/** Serial writes keep undo deterministic even while a save is still in flight. */
export interface AnnotationCommand { label: string; undo: () => Promise<void>; redo: () => Promise<void>; }
export class AnnotationHistory {
  private past: AnnotationCommand[] = [];
  private future: AnnotationCommand[] = [];
  private tail: Promise<unknown> = Promise.resolve();
  pending = 0;
  private changed: () => void;
  constructor(changed: () => void = () => {}) {this.changed=changed;}
  get canUndo() { return this.past.length > 0; }
  get canRedo() { return this.future.length > 0; }
  private enqueue<T>(work: () => Promise<T>): Promise<T> {
    this.pending++; this.changed();
    const result = this.tail.then(work);
    this.tail = result.catch(() => undefined).finally(() => { this.pending--; this.changed(); });
    return result;
  }
  perform(work: () => Promise<AnnotationCommand | null>) {
    return this.enqueue(async () => {
      const command = await work();
      if (command) { this.past.push(command); this.future = []; if (this.past.length > 100) this.past.shift(); }
    });
  }
  undo() {
    return this.enqueue(async () => {
      const command = this.past.at(-1);
      if (!command) return;
      await command.undo();
      this.past.pop(); this.future.push(command);
    });
  }
  redo() {
    return this.enqueue(async () => {
      const command = this.future.at(-1);
      if (!command) return;
      await command.redo();
      this.future.pop(); this.past.push(command);
    });
  }
}
